const ComponentsLookup = {
  "default-footer": "DefaultFooterD627caf25843413c848268db114c7394"
}

export default ComponentsLookup;